import { format } from "date-fns";
import { DataTable, DataTableColumnDef } from "@/components/molecules";
import { useProfile } from "@/hooks";
import { BookingRefundActivityLog } from "@/redux/slices/booking/types";
import { formatCurrency } from "@/utils";
import { useSelectedBooking } from "../../../hooks/useSelectedBooking";
import { getRefundType, getRefundFromTo } from "../helpers";
import { RefundActivityData } from "../types";

const refundActivityColumns: DataTableColumnDef<RefundActivityData>[] = [
  {
    header: "Refund Date",
    accessorKey: "refundDate",
    size: 120,
    enableSorting: false,
  },
  {
    header: "Amount",
    accessorKey: "amount",
    size: 90,
    enableSorting: false,
  },
  {
    header: "Type",
    accessorKey: "type",
    size: 180,
    enableSorting: false,
  },
  {
    header: "From → To",
    accessorKey: "fromTo",
    size: 180,
    enableSorting: false,
  },
  {
    header: "Reason for Refund",
    accessorKey: "reasonForRefund",
    enableSorting: false,
  },
];

export const RefundActivityTable = ({ items }: { items: BookingRefundActivityLog[] }) => {
  const { dateFormat } = useProfile();
  const {
    cost: { currency },
  } = useSelectedBooking();

  const data: RefundActivityData[] = [...items]
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .map((item) => {
      const amount = Math.abs(item.amount);
      const formattedAmount = formatCurrency(amount, 2, currency);
      const displayAmount = item.type === "payment_out" ? `-${formattedAmount}` : `+${formattedAmount}`;

      return {
        id: item.id,
        refundDate: format(new Date(item.createdAt), dateFormat),
        amount: displayAmount,
        type: getRefundType(item.type, item.description, item.category),
        fromTo: getRefundFromTo(item.type, item.category),
        reasonForRefund: item.refundDescription || "-",
      };
    });

  return <DataTable data={data} columns={refundActivityColumns} className="mt-5 w-full overflow-x-auto [&_table]:table-auto" />;
};
